function videoLink(url, type) {
    if ( type == 'youtube') {
        url = 'https://www.youtube.com/embed/' + url;
        url = url + "?wmode=transparent&amp;modestbranding=1&amp;rel=0&amp;autoplay=0&amp;mute=0"
        document.getElementById("youtube_video").src = url;
    } else {
        url = 'https://player.vimeo.com/video/' + url;
        document.getElementById("youtube_video").src = url;
    }
}

function playerVideo() {
    document.getElementById('cover_image').style.display = 'none';
    document.getElementById('play_icon').style.display = 'none';
    var iframe = document.getElementById('youtube_video');
    iframe.style.display = 'block';
    if(iframe.src.includes("autoplay=0")){
        iframe.src = iframe.src.replace("autoplay=0", "autoplay=1");
    }
    iframe.addEventListener("fullscreenchange", () => {
        closeInstagramVideoIfFullscreenActive(iframe);
    });
}

function closeInstagramVideoIfFullscreenActive(iframe) {
    if(document.fullscreenElement == null){
        iframe.src = iframe.src.replace("autoplay=1", "autoplay=0");
        document.getElementById('cover_image').style.display = 'block';
        document.getElementById('play_icon').style.display = 'block';
        document.getElementById('youtube_video').style.display = 'none';
    }
}

function hidePictures() {
    if (window.innerWidth >= 1280) {
        setTimeout(() => {
            let photos = document.getElementById('insta-feed');
            if (photos.children[5]) {
                photos.children[5].style.display = 'inline';
            }
            if (photos.children[4]) {
                photos.children[4].style.display = 'inline';
            }
        }, 100);
    }
}

function instaFeed() {
    // window.addEventListener('load', hidePictures);
    // window.addEventListener('resize', hidePictures);
}